import { render, staticRenderFns } from "./specialistForWorkSafety.vue?vue&type=template&id=38921471"
import script from "./specialistForWorkSafety.vue?vue&type=script&lang=js"
export * from "./specialistForWorkSafety.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports